<template>
  <div class="mt-section-header">
    <h2 class="mt-title">
      <slot />
    </h2>

    <div>
      <slot name="right" />
    </div>
  </div>
</template>
